export default __webpack_public_path__ + "static/media/DSC_0552.cae4a63c.webp";